"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var AgentsApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(AgentsApi, _BasicProviderApi);

  /**
   * Represents a Agents Api.
   * @constructor
   */
  function AgentsApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage;
    (0, _classCallCheck2.default)(this, AgentsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AgentsApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage
    }));
  }
  /**
   *
   * @param {String} param0.projection projection for get specified fields
   * @param {Number} param1.limit id of agent
   * @param {Object} param2.last last id
   * @returns {Array} of agents list
   */


  (0, _createClass2.default)(AgentsApi, [{
    key: "getAgentsList",
    value: function () {
      var _getAgentsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _ref2,
            projection,
            chunked,
            limit,
            last,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, projection = _ref2.projection, chunked = _ref2.chunked, limit = _ref2.limit, last = _ref2.last;
                _context.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents',
                  queryParams: {
                    projection: projection,
                    chunked: chunked,
                    limit: limit,
                    last: last
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAgentsList() {
        return _getAgentsList.apply(this, arguments);
      }

      return getAgentsList;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {String} param1.projection projection for get specified fields
     * @returns {Object} agent
     */

  }, {
    key: "getAgent",
    value: function () {
      var _getAgent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var agentId, projection;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                agentId = _ref3.agentId, projection = _ref3.projection;
                _context2.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId,
                    projection: projection
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAgent(_x) {
        return _getAgent.apply(this, arguments);
      }

      return getAgent;
    }()
    /**
     *
     * @param {Array} param0.agentIds ids of agent
     * @param {String} param1.projection projection for get specified fields
     * @param {Number} param2.limit id of agent
     * @param {Object} param3.last last id
     * @returns {Array} agents
     */

  }, {
    key: "getAgents",
    value: function () {
      var _getAgents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4) {
        var agentIds, projection;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                agentIds = _ref4.agentIds, projection = _ref4.projection;
                _context3.next = 3;
                return this._callApi({
                  method: 'get',
                  path: "/hitl/agents",
                  queryParams: {
                    agentIds: agentIds,
                    projection: projection
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAgents(_x2) {
        return _getAgents.apply(this, arguments);
      }

      return getAgents;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {Array} param0.rulesGroups groups of rules for agent
     */

  }, {
    key: "updateAgentRulesGroups",
    value: function () {
      var _updateAgentRulesGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref5) {
        var agentId, rulesGroups;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                agentId = _ref5.agentId, rulesGroups = _ref5.rulesGroups;
                _context4.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    rulesGroups: rulesGroups
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateAgentRulesGroups(_x3) {
        return _updateAgentRulesGroups.apply(this, arguments);
      }

      return updateAgentRulesGroups;
    }()
    /**
     *
     * @returns {Object} agent actual status if exists or default status settings
     */

  }, {
    key: "getActualAgentStatus",
    value: function () {
      var _getActualAgentStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents/actual-status',
                  errorName: 'AgentError'
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getActualAgentStatus() {
        return _getActualAgentStatus.apply(this, arguments);
      }

      return getActualAgentStatus;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {String} param1.status agent status - Online, Busy, Offline
     * @param {String} param2.lastStatusUpdate date in ISO string format last update of status
     * @param {String} param3.busyReason reason of BUSY
     * @param {String} param4.v api version
     */

  }, {
    key: "updateAgentStatus",
    value: function () {
      var _updateAgentStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref6) {
        var agentId, status, lastStatusUpdate, busyReason, v;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                agentId = _ref6.agentId, status = _ref6.status, lastStatusUpdate = _ref6.lastStatusUpdate, busyReason = _ref6.busyReason, v = _ref6.v;
                _context6.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/agents/status',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    statusData: {
                      status: status,
                      lastStatusUpdate: lastStatusUpdate,
                      busyReason: busyReason
                    },
                    v: v
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateAgentStatus(_x4) {
        return _updateAgentStatus.apply(this, arguments);
      }

      return updateAgentStatus;
    }()
    /**
     * @param {String} param0.agentId agentId
     * @param {Array} param1.addRulesGroups array of groups ids add to agent groups
     * @param {Array} param2.removeRulesGroups array of groups ids remove to agent groups
     * @returns {Object} agent groups
     */

  }, {
    key: "patchAgentRulesGroup",
    value: function () {
      var _patchAgentRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref7) {
        var agentId, addRulesGroups, removeRulesGroups;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                agentId = _ref7.agentId, addRulesGroups = _ref7.addRulesGroups, removeRulesGroups = _ref7.removeRulesGroups;
                _context7.next = 3;
                return this._callApi({
                  method: 'patch',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    addRulesGroups: addRulesGroups,
                    removeRulesGroups: removeRulesGroups
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function patchAgentRulesGroup(_x5) {
        return _patchAgentRulesGroup.apply(this, arguments);
      }

      return patchAgentRulesGroup;
    }()
    /**
     *
     * @returns {Array} rules groups list
     */

  }, {
    key: "getRulesGroupsList",
    value: function () {
      var _getRulesGroupsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8() {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  errorName: 'RulesGroupsError'
                });

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRulesGroupsList() {
        return _getRulesGroupsList.apply(this, arguments);
      }

      return getRulesGroupsList;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @returns {Object} (object | array) rules group or rules groups
     */

  }, {
    key: "getRulesGroup",
    value: function () {
      var _getRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref8) {
        var groupId;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                groupId = _ref8.groupId;
                _context9.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRulesGroup(_x6) {
        return _getRulesGroup.apply(this, arguments);
      }

      return getRulesGroup;
    }()
    /**
     * @param {Array} param0.groupIds ids of rules group
     * @returns {Object} (object | array) rules group or rules groups
     */

  }, {
    key: "getRuleGroups",
    value: function () {
      var _getRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref9) {
        var groupIds;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                groupIds = _ref9.groupIds;
                _context10.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  queryParams: {
                    groupIds: groupIds
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getRuleGroups(_x7) {
        return _getRuleGroups.apply(this, arguments);
      }

      return getRuleGroups;
    }()
    /**
     * @param {String} param0.name name of rules group
     * @param {Array} param1.rules agent permissions rules
     * @returns {Object} add stats
     */

  }, {
    key: "addRulesGroup",
    value: function () {
      var _addRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref10) {
        var name, rules;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                name = _ref10.name, rules = _ref10.rules;
                _context11.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/rules-groups',
                  payload: {
                    name: name,
                    rules: rules
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function addRulesGroup(_x8) {
        return _addRulesGroup.apply(this, arguments);
      }

      return addRulesGroup;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @param {String} param1.name name of rules group
     * @param {Array} param2.rules agent permissions rules
     * @returns {Object} update stats
     */

  }, {
    key: "updateRulesGroup",
    value: function () {
      var _updateRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref11) {
        var groupId, name, rules;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                groupId = _ref11.groupId, name = _ref11.name, rules = _ref11.rules;
                _context12.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/rules-groups',
                  payload: {
                    groupId: groupId,
                    name: name,
                    rules: rules
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context12.abrupt("return", _context12.sent);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function updateRulesGroup(_x9) {
        return _updateRulesGroup.apply(this, arguments);
      }

      return updateRulesGroup;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteRulesGroup",
    value: function () {
      var _deleteRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref12) {
        var groupId;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                groupId = _ref12.groupId;
                _context13.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/rules-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteRulesGroup(_x10) {
        return _deleteRulesGroup.apply(this, arguments);
      }

      return deleteRulesGroup;
    }()
    /**
     *
     * @param {Array} param0.groupIds ids of agent rules groups
     * @param {String} param1.status status of agents
     * @returns {Array} agents
     */

  }, {
    key: "searchAgents",
    value: function () {
      var _searchAgents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref13) {
        var rulesGroupsIds, status, ruleTags, excludeRequestAgent;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                rulesGroupsIds = _ref13.rulesGroupsIds, status = _ref13.status, ruleTags = _ref13.ruleTags, excludeRequestAgent = _ref13.excludeRequestAgent;
                _context14.next = 3;
                return this._callApi({
                  method: 'get',
                  path: "/agents/search",
                  queryParams: {
                    rulesGroupsIds: rulesGroupsIds,
                    status: status,
                    ruleTags: ruleTags,
                    excludeRequestAgent: excludeRequestAgent
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function searchAgents(_x11) {
        return _searchAgents.apply(this, arguments);
      }

      return searchAgents;
    }()
    /**
     * @param {String} param0.name part of name to search groups
     * @param {Array} param1.rules list of rules to search groups
     * @param {Array} param2.projection projection of data base
     * @param {Integer} param3.size a number of search groups to receive
     * @param {Integer} param4.from a number of first rule group from the list
     * @param {String} param5.sort sorting method
     * @returns {Array} rules groups
     */

  }, {
    key: "searchRulesGroup",
    value: function () {
      var _searchRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref14) {
        var name, rules, projection, size, from, sort;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                name = _ref14.name, rules = _ref14.rules, projection = _ref14.projection, size = _ref14.size, from = _ref14.from, sort = _ref14.sort;
                _context15.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/rules-groups/search',
                  payload: {
                    name: name,
                    rules: rules,
                    projection: projection,
                    size: size,
                    from: from,
                    sort: sort
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function searchRulesGroup(_x12) {
        return _searchRulesGroup.apply(this, arguments);
      }

      return searchRulesGroup;
    }()
  }]);
  return AgentsApi;
}(_basic_provider.default);

var _default = AgentsApi;
exports.default = _default;